export default __webpack_public_path__ + "static/media/Flickr.dcfafbcb.svg";